module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<div>\n    <span>' +
__e( skillTitle ) +
':</span>\n    <em>' +
__e( currentResponse ) +
'</em>\n</div>\n' +
__e( count ) +
' of ' +
__e( total ) +
'\n';

}
return __p
}